<template>
<div class="card">
  <div class="card-header">
    <h5 class="mb-0">Track Survey Member</h5>
  </div>
  <div class="card-body">
    <div class="mb-3">
      <label class="form-label">Questionnaire link</label>
      <input type="text" class="form-control" v-model="link" />
    </div>
    <div class="mb-3">
      <label class="form-label">Show log level</label>
      <select
        class="form-select"
        v-model="loglevel"
      >
        <option v-for="level in loglevels" :key="level.value" :value="level.value">
          {{ level.text }}
        </option>
      </select>
    </div>
    <button class="btn btn-primary" @click.prevent="getlog">Get tracking</button>
    
    <div class="table-responsive mt-3">
      <table class="table table-hover" id="tracking">
        <thead>
          <tr>
            <th>Date</th>
            <th>Operation</th>
            <th>Browser</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in records" :key="item.access_date + item.operation">
            <td>{{ item.access_date }}</td>
            <td>{{ item.operation }}</td>
            <td>{{ item.browser }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>
<script>
import axios from 'axios'
import { config } from '../../config';
const base_url = config.base_url;
const api_token = config.api_token;

const loglevels = [
  { value: 1, text: 'Summary'},
  { value: 5, text: 'Details'},
];

const fields = [
  { key: "access_date", label: "Date", sortable: true },
  { key: "operation", label: "Operation", sortable: false },
  { key: "browser", label: "Browser", sortable: false },
];

export default {
  name: 'TrackSurveyMember',
  data: function() {
    return {
      link: '',
      records: [],
      fields: fields,
      loglevel: 1,  
      loglevels: loglevels,    
    }
  },
  methods: {
    async getlog() {
      this.records = [];
      const filter = {
        url: {
          operator: '=',
          value: this.link,
        },
        loglevel: {
          operator: '<=',
          value: this.loglevel,
        }
      }
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      const url = base_url+"/g_accesslog?"
                + 'orderby=access_date'
                + '&order=DESC' 
                +'&filter='+JSON.stringify(filter)
      axios.get(
        url,
        {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
      )
      .then(async(resp) => {
        for (const e of resp.data.result){
          // let thisbrowser = await this.getinformation(e.user_agent);
          const row =  {
            access_date: e.access_date,
            operation: e.operation,
            browser: e.user_agent, //thisbrowser,
          }
          this.records.push(row);
        }
      });
    },
    async getinformation(b) {
      const data = {
        b: b,
      }
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      return await axios.post(
        'https://api.eventerex.com/gdq/gdq_getbrowser.php',
        JSON.stringify(data), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
      )
      .then((resp) => {
        return resp.data.device_type+' '+resp.data.platform+' '+resp.data.browser+' '+resp.data.version;
      })          
    },
  }
  
}
</script>
<style scoped>

</style>
